import { Key } from "../../models";
import { runAction } from "../client";

export interface GetGroupParamsRequest
{
    Name: string;
    Ids: Key[];
}

export interface GetGroupParamsResult
{
    AxlesCount: number;
}

export interface GetGroupParamsFn
{
    (params: GetGroupParamsRequest): Promise<GetGroupParamsResult>;
}

export const getGroupParams: GetGroupParamsFn = (params: GetGroupParamsRequest) => {
    return runAction('/action/GetGroupParams', params);
}


// WEBPACK FOOTER //
// ./src/rest/Misc/group-params.ts